import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { DateRangePagerComponent } from '@src/suite/common/components/date-range-pager/date-range-pager';
import { selectViewDateRange } from '@src/suite/common/store/cast/cast.selectors';

@Component({
    selector: 'st-cast-right-slot',
    imports: [DateRangePagerComponent, MatButtonToggleModule, MatListModule, MatMenuModule, MatTooltipModule],
    templateUrl: './cast-right-slot.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-cast-right-slot',
    },
})
export class CastRightSlotComponent {
    store = inject(Store);

    currentPeriod = this.store.selectSignal(selectViewDateRange);
}
